var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-video',{staticClass:"video",attrs:{"src":_vm.video,"controls":"controls"}})
}
var staticRenderFns = []

export { render, staticRenderFns }